import {RiverBreakout, Text, Link, Stack, Statistic} from '@primer/react-brand'
import {renderWithNoMarks, renderPoints} from '../../utils'
import type {RiverBreakout as RiverBreakoutProps} from '../../types'
import styles from './FlexSuiteRiverBreakout.module.css'
import {t} from '@github-ui/swp-core/lib/utils/localization'

export type FlexSuiteRiverBreakoutProps = RiverBreakoutProps['fields']

export const FlexSuiteRiverBreakout = ({
  heading,
  includeCta,
  label,
  href,
  alt,
  supportingContent,
  pointOne,
  pointTwo,
  pointThree,
  statistics,
  customerStories,
}: FlexSuiteRiverBreakoutProps) => {
  let trailingContent
  if (supportingContent === 'Points') {
    trailingContent = () => (
      <Stack>
        {pointOne && renderPoints(pointOne)}
        {pointTwo && renderPoints(pointTwo)}
        {pointThree && renderPoints(pointThree)}
      </Stack>
    )
  }

  if (supportingContent === 'Statistics') {
    trailingContent = () => {
      const stats = statistics?.map(stat => {
        const id = stat.sys.id
        const {heading: statHeading, description} = stat.fields
        return (
          <Statistic key={id}>
            <Statistic.Heading>{renderWithNoMarks(statHeading)}</Statistic.Heading>
            <Statistic.Description>{renderWithNoMarks(description)}</Statistic.Description>
          </Statistic>
        )
      })

      return <Stack>{stats}</Stack>
    }
  }
  if (supportingContent === 'Customer Stories' && customerStories?.length) {
    /*
     * This is a temporary implementation for customer stories.
     * It will be replaced when the proper component is ready in the Brand Refactor.
     */
    const stories = customerStories.map(story => {
      const id = story.sys.id
      const {logo, lead, url, title} = story.fields
      return (
        <div key={id} className={styles.customerStory}>
          <img className={styles.customerStoryLogo} src={logo.fields.file.url} alt={logo.fields.description || title} />
          <Stack>
            <Text variant="muted">{lead}</Text>
            <Link href={url} variant="accent">
              {t('Learn more')}
              <span className="sr-only">: {title}</span>
            </Link>
          </Stack>
        </div>
      )
    })

    trailingContent = () => <Stack>{stories}</Stack>
  }
  return (
    <RiverBreakout>
      {/* Will add visual content here after https://github.com/github/marketing-engineering/issues/5468 */}
      <RiverBreakout.Visual>{/* Visual */}</RiverBreakout.Visual>
      <RiverBreakout.Content {...(trailingContent && {trailingComponent: trailingContent})}>
        {[
          <Text key={heading.nodeType}>{renderWithNoMarks(heading)}</Text>,
          ...(includeCta && href && label
            ? [
                <Link key={href} href={href} {...(alt ? {'aria-label': alt} : {})}>
                  {label}
                </Link>,
              ]
            : []),
        ]}
      </RiverBreakout.Content>
    </RiverBreakout>
  )
}
